import React, { FC } from 'react';

import VideosBlock from '~/components/VideosBlock/VideosBlock';
import { formatVideoForVideoBlock } from '~/components/VideosBlock/VideosBlock';
import { useUserInfoContext } from '~/context/UserInfoProvider';
import useTenantTranslation from '~/hooks/useTenantTranslation';
import { useIsWidthUp } from '~/theme';
import { Background, Orientation, Video } from '~/types';
import { toBoolean } from '~/utils/toBoolean';

interface RelatedVideosProps {
  videos: (Video | null)[];
  loading?: boolean;
}

const RelatedVideos: FC<RelatedVideosProps> = ({ videos, loading }) => {
  const { t } = useTenantTranslation();
  const { userInfo } = useUserInfoContext();
  const isMobile = !useIsWidthUp('sm');

  const videosForBlock = videos?.filter(toBoolean<Video>).map(formatVideoForVideoBlock) || [];

  const title = t(userInfo ? 'page.video.youMayAlsoLike' : 'page.video.relatedVideos');

  return (
    <VideosBlock
      loading={loading}
      data={{
        heading: title,
        items: videosForBlock,
        background: userInfo ? Background.Light : Background.Dark,
        orientation: Orientation.Lanscape,
      }}
      titleToLeft={isMobile}
      withChunksOnMobile
    />
  );
};

export default RelatedVideos;
